/** «Бухгалтерия»: CSV download paths for the chosen period (pure). */

export function pnlCsvPath(from: string, to: string): string {
  return `/accounting/export.csv?date_from=${encodeURIComponent(from)}&date_to=${encodeURIComponent(to)}`
}

export function pnlCsvName(from: string, to: string): string {
  return `aivy-pnl-${from.slice(0, 7)}-${to.slice(0, 7)}.csv`
}

export function byModelCsvPath(from: string, to: string): string {
  return `/accounting/by-model.csv?date_from=${encodeURIComponent(from)}&date_to=${encodeURIComponent(to)}`
}
